import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { Cell } from "../cells.entity";
import { CellDTO } from "./cells.dto";

export class CellAdapter {
    convertDtoToEntity(dtoObj: CellDTO,  isUpdate: boolean = false ): Cell {
        try {
            const entityObj = new Cell();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.cellCode = dtoObj.cellCode;
            entityObj.cellName = dtoObj.cellName;
            if (dtoObj.cellId) {
                entityObj.cellId = dtoObj.cellId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(cellObject: Cell): CellDTO {
        const cellDTO= new CellDTO;
        cellDTO.cellId = cellObject.cellId;
        cellDTO.cellCode = cellObject.cellCode;
        cellDTO.cellName = cellObject.cellName;
        cellDTO.isActive = cellObject.isActive;
        cellDTO.createdAt = cellObject.createdAt;
        cellDTO.updatedAt = cellObject.updatedAt;
        cellDTO.createdUser = cellObject.createdUser;
        cellDTO.updatedUser = cellObject.updatedUser;
        cellDTO.versionFlag = cellObject.versionFlag;
        return cellDTO;
      }
}